import { useEffect, useRef, useState } from 'react';
import './TestimonialsSection.css';

const testimonials = [
  {
    name: 'Carlos Martínez',
    role: 'Cliente habitual',
    text: 'Llevo 3 años viniendo a Barber Studio Luisfer y nunca me ha fallado. El nivel de detalle y precisión en cada corte es increíble. Sin duda la mejor barbería de Barranquilla.',
    rating: 5,
    initial: 'C',
  },
  {
    name: 'Alejandro Ruiz',
    role: 'Cliente',
    text: 'La experiencia es completamente diferente a cualquier barbería que haya visitado. El ambiente, la atención, los productos... todo de primera categoría. Luisfer es un artista.',
    rating: 5,
    initial: 'A',
  },
  {
    name: 'Miguel Ángel Torres',
    role: 'Cliente VIP',
    text: 'Vine por primera vez hace 6 meses y desde entonces no voy a ningún otro lado. Mi barba nunca ha lucido tan bien y los cortes que hace Luisfer son de otro nivel.',
    rating: 5,
    initial: 'M',
  },
  {
    name: 'Sergio López',
    role: 'Cliente',
    text: 'Reservé para un evento importante y quedé más que satisfecho. El resultado superó mis expectativas. Profesionalismo, ambiente premium y un trato excelente.',
    rating: 5,
    initial: 'S',
  },
];

export default function TestimonialsSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="testimonials-section py-24 md:py-32 relative"
    >
      <div className="testimonials-section-top-line absolute top-0 left-0 right-0" />

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div
          className={`text-center mb-14 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <p className="testimonials-section-label mb-4">◆ Testimonios ◆</p>
          <h2 className="testimonials-section-title">
            Lo que dicen nuestros clientes
          </h2>
          <div className="testimonials-section-divider" />
        </div>

        {/* Cards */}
        <div className="testimonials-grid">
          {testimonials.map((t, idx) => (
            <div
              key={idx}
              className="testimonial-card"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(24px)',
                transitionDelay: `${idx * 100}ms`,
                transitionDuration: '600ms',
              }}
            >
              {/* Stars */}
              <div className="testimonial-stars">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill testimonial-star" />
                ))}
              </div>

              {/* Quote */}
              <p className="testimonial-text">
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Author */}
              <div className="testimonial-author">
                <div className="testimonial-avatar">
                  {t.initial}
                </div>
                <div>
                  <p className="testimonial-name">{t.name}</p>
                  <p className="testimonial-role">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}